import type {
	CustomItem,
	DropVideoType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropVideo = (item: Item | CustomItem): item is DropVideoType => {
	return !!(item && item.__typename === 'Drop_Video');
};
